module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Night-rain-1bfbda90b876fe3f9c4d6a8cf0ef2074.svg";